import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||1623}
    height={props.width? `calc( ${props.width}/ 1623 * 854 )`: 854}
    viewBox="0 0 1623 854"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.8}
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m1563.34 557.785 58.66 58.714v236.056H74.559L1 778.928V278.422l47.415-47.45V2H1476.67l86.02 86.111.65 469.674Z"
    />
    <path
      fill="url(#aqq)"
      fillOpacity={0.5}
      stroke="#fff"
      strokeWidth={2}
      d="m606.982 74.39.297-.294V1H49.451v102.88h527.655l.292-.288 29.584-29.203Z"
    />

   
    <path fill="#67FFED" d="M35.616 2h-6.532L1 29.692h6.531L35.616 2Z" />
    <path
      fill="#fff"
      d="M35.616 209.694h-6.532L1 237.386h6.531l28.085-27.692ZM35.616 179.034h-6.532L1 206.727h6.531l28.085-27.693Z"
    />
    <defs>
      <linearGradient
        id="aqq"
        x1={-137.688}
        x2={-137.688}
        y1={102.88}
        y2={2}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.51} stopColor="#FFF1D6" stopOpacity={0.49} />
        <stop offset={1} stopColor="#FFC046" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
